import { RestRequest, } from '@Utils/rest';
import { CacheGlobalSubjectEnum, } from 'atlas-shared';

export const fetchGlobalData = async <T extends any>(key: string): Promise<{subject: CacheGlobalSubjectEnum; payload: T}> => {
  return RestRequest.get(`/global/data/${key}`);
};
